/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'project-contributors-picker.done': 'Terminé',
  'project-contributors-picker.go-back-label': 'Retour',
  'project-contributors-picker.header': 'Sélectionner des membres du projet',
  'project-contributors-picker.your-teams-secondary-text':
    '{membersCount, plural, one {{membersCount,number} membre} other {{membersCount,number} membres}}',
  'project-contributors-picker.your-teams-secondary-text-focused':
    '{membersCount, plural, one {Sélectionner à partir de {membersCount,number} membre} other {Sélectionner à partir de {membersCount,number} membres}}',
  'project-contributors-picker.your-teams-title': 'Vos équipes',
  'project-fields.common.generic-error.description': 'Vérifiez votre connexion Internet et réessayez.',
  'project-fields.common.generic-error.title': 'Une erreur est survenue',
  'project-fields.link-item.delete-label': 'Supprimer',
  'project-fields.link-item.edit-label': 'Modifier',
  'project-fields.project-contributes-to.add-goal-title': 'Ajouter un objectif',
  'project-fields.project-contributes-to.empty-title': 'Aucun objectif',
  'project-fields.project-contributes-to.title': 'Contribue à',
  'project-fields.project-contributors.add-contributors-title': 'Ajouter des contributeurs',
  'project-fields.project-contributors.empty-title': 'Aucun contributeur',
  'project-fields.project-contributors.remove-contributor': 'Supprimer un contributeur',
  'project-fields.project-contributors.remove-contributor-error-message': 'Impossible de supprimer le contributeur',
  'project-fields.project-contributors.remove-team': "Supprimer l'équipe",
  'project-fields.project-contributors.show-more': 'Afficher plus',
  'project-fields.project-contributors.title': 'Contributeurs',
  'project-fields.project-contributors.view-profile': 'Afficher le profil',
  'project-fields.project-contributors.view-profile-team': 'Afficher le profil',
  'project-fields.project-focus-areas.title': 'Domaines prioritaires',
  'project-fields.project-followers.add-followers-title': 'Ajouter des abonnés',
  'project-fields.project-followers.empty-title': 'Aucun abonné',
  'project-fields.project-followers.title': 'Abonnés',
  'project-fields.project-link-picker.aria-label': 'Liens récemment consultés',
  'project-fields.project-link-picker.invalid-link-input.error': 'Vérifiez que votre lien est une URL valide.',
  'project-fields.project-link-picker.link-input.clear-label': 'Effacer le lien',
  'project-fields.project-link-picker.link-input.placeholder':
    'Coller un lien ou rechercher les pages récemment consultées',
  'project-fields.project-link-picker.text-input.clear-label': 'Effacer le texte',
  'project-fields.project-link-picker.text-input.placeholder': 'Texte à afficher (facultatif)',
  'project-fields.project-links.add-links-title': 'Ajouter des liens',
  'project-fields.project-links.add-links-tooltip':
    'Ajoutez des liens vers des documents, des conceptions et plus encore',
  'project-fields.project-links.delete-link-button': 'Supprimer le lien',
  'project-fields.project-links.edit-link-button': 'Modifier le lien',
  'project-fields.project-links.empty-title': 'Aucun lien',
  'project-fields.project-links.title': 'Liens',
  'project-fields.project-owner.title': 'Propriétaire',
  'project-fields.project-start-date.add-start-date-title': 'Ajouter une date de début',
  'project-fields.project-start-date.cancel-button': 'Enregistrer',
  'project-fields.project-start-date.creation-date': 'Ce projet a été créé le {creationDate}',
  'project-fields.project-start-date.edit-start-date-label': 'Modifier la date de début du projet',
  'project-fields.project-start-date.empty-title': 'Aucune date de début',
  'project-fields.project-start-date.enter-start-date-title': 'Saisissez une date de début',
  'project-fields.project-start-date.open-calendar-label': 'Ouvrir le calendrier',
  'project-fields.project-start-date.read-only':
    "Seuls les contributeurs disposant d'un accès en modification peuvent changer la date de début.",
  'project-fields.project-start-date.title': 'Date de début',
  'project-fields.project-state.archived': 'Archivés',
  'project-fields.project-state.at-risk': 'À risque',
  'project-fields.project-state.cancelled': 'Annulé',
  'project-fields.project-state.completed': 'Terminé(s) 🎉',
  'project-fields.project-state.off-track': 'Compromis',
  'project-fields.project-state.on-track': 'Sur la bonne voie',
  'project-fields.project-state.paused': 'Interrompu(s)',
  'project-fields.project-state.pending': 'En attente',
  'project-fields.project-status-picker.project-status-picker-more-button': "Plus d'états",
  'project-fields.project-status.title': 'État',
  'project-fields.project-tags.add-tags-title': 'Ajouter des tags',
  'project-fields.project-tags.empty-title': 'Aucun thème',
  'project-fields.project-tags.title': 'Tags',
  'project-fields.project-target-date.picker-placeholder': 'En attente',
  'project-fields.project-target-date.title': 'Date cible',
  'project-fields.project-work-items.show-all-non-final': 'Afficher tout',
  'project-fields.project-work-items.show-less-non-final': 'Afficher moins',
  'project-fields.project-work-tracked-picker.cancel-button': 'Enregistrer',
  'project-fields.project-work-tracked-picker.fallback-description':
    "Ajoutez un lien vers l'endroit où vous suivez le travail pour ce projet",
  'project-fields.project-work-tracked-picker.fallback-invalid-url': 'Veuillez saisir une URL valide',
  'project-fields.project-work-tracked-picker.no-recently-viewed-header': 'Rechercher des tickets Jira',
  'project-fields.project-work-tracked-picker.no-recently-viewed-result':
    'Recherchez ou ajoutez des liens vers des sites où vous suivez le travail effectué pour ce projet.',
  'project-fields.project-work-tracked-picker.no-search-result':
    "Essayez de saisir à nouveau la clé ou l'URL du ticket Jira, ou utilisez d'autres termes pour effectuer la recherche.",
  'project-fields.project-work-tracked-picker.no-search-results-header': 'Aucune correspondance trouvée',
  'project-fields.project-work-tracked-picker.recently-viewed-title': 'Récemment consultés',
  'project-fields.project-work-tracked-picker.results-title': 'Résultats',
  'project-fields.project-work-tracked-picker.search-placeholder': 'Rechercher dans Jira ou ajouter un lien',
  'project-fields.project-work-tracked-picker.sync-form-description':
    'Associez ce projet au ticket Jira sélectionné pour synchroniser automatiquement les informations.',
  'project-fields.project-work-tracked-picker.sync-form-warning':
    'Notez que toute personne qui peut voir ce ticket Jira verra les informations de votre projet.',
  'project-fields.project-work-tracked-picker.sync-with-jira-button': 'Synchroniser avec Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-cancel-button': 'Annuler',
  'project-fields.project-work-tracked-picker.sync-with-jira-connect-button': 'Connecter',
  'project-fields.project-work-tracked-picker.sync-with-jira-detail-selection':
    'Sélectionnez les informations que vous souhaitez désormais utiliser pour cette tâche :',
  'project-fields.project-work-tracked-picker.sync-with-jira-header': 'Synchronisez ce projet avec Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing': 'Synchronisation des étiquettes',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing-description':
    'Synchronisez les étiquettes Jira avec les rubriques du projet',
  'project-fields.project-work-tracked-picker.sync-with-jira-project-name': 'Nom du projet',
  'project-fields.project-work-tracked-picker.sync-with-jira-start-date': 'Date de début',
  'project-fields.project-work-tracked-picker.sync-with-jira-target-date': 'Date cible',
  'project-fields.project-work-tracked-picker.sync-with-jira-via-project': '{projectName} {viaProject}',
  'project-fields.project-work-tracked-picker.text-placeholder': 'Lien de suivi du travail',
  'project-fields.project-work-tracked-picker.work-tracked-picker-content':
    'Recherchez des tickets Jira ou ajoutez des liens vers les sites où vous suivez le travail lié à ce projet.',
  'project-fields.project-work-tracked-picker.work-tracked-picker-title': 'Où le travail est-il suivi ?',
  'project-fields.project-work-tracked.add-work-tracked-title': 'Ajouter des tickets Jira',
  'project-fields.project-work-tracked.empty-title': 'Aucun ticket Jira',
  'project-fields.project-work-tracked.linked-with-jira-label': 'Associé à Jira',
  'project-fields.project-work-tracked.sync-now-label': 'Synchroniser',
  'project-fields.project-work-tracked.synced-with-jira-label': 'Synchronisé avec Jira',
  'project-fields.project-work-tracked.title': 'Ticket suivi',
  'project-fields.related-project-picker.add-button-label': 'Ajouter',
  'project-fields.related-project-picker.cancel-button-label': 'Annuler',
  'project-fields.related-project-picker.depended-by-option-label': 'Le projet influence',
  'project-fields.related-project-picker.depends-on-option-label': 'Le projet dépend de',
  'project-fields.related-project-picker.empty-state-description':
    'Trouvez des projets connexes à associer à ce projet.',
  'project-fields.related-project-picker.empty-state-title': 'Rechercher des projets',
  'project-fields.related-project-picker.project-relationship-type-label': 'Sélectionnez le type de relation de projet',
  'project-fields.related-project-picker.project-search-placeholder': 'Rechercher des projets',
  'project-fields.related-project-picker.related-option-label': 'Le projet est associé à',
  'project-fields.related-project-picker.related-project-list-label': 'Projets associés',
  'project-fields.related-projects.add-related-title': 'Ajouter des projets associés',
  'project-fields.related-projects.add-related-tooltip': 'Ajouter un projet dépendant ou associé',
  'project-fields.related-projects.dependent-by-projects-heading': 'Influencé par',
  'project-fields.related-projects.dependent-on-projects-heading': 'Dépend de',
  'project-fields.related-projects.empty-title': 'Aucun projet associé',
  'project-fields.related-projects.related-projects-heading': 'Associé à',
  'project-fields.related-projects.title': 'Associé',
  'project-fields.use-project-flags.generic-error-description':
    "Une erreur s'est produite. Veuillez réessayer dans quelques minutes.",
  'project-fields.use-project-flags.generic-error-title': 'Une erreur est survenue',
  'project-fields.use-project-flags.project-links-add-failure-title': "Impossible d'ajouter le lien",
  'project-fields.use-project-flags.project-links-delete-failure-title': 'Impossible de supprimer le lien',
  'project-fields.use-project-flags.project-links-edit-failure-title': 'Impossible de modifier le lien',
  'project-fields.use-project-flags.project-owner-change-error-header':
    'Impossible de modifier le propriétaire du projet',
  'project-fields.use-project-flags.project-start-date-change-error-header':
    'Impossible de mettre à jour la date de début du projet',
  'project-fields.use-project-flags.project-tags-add-failure-title': "Impossible d'ajouter la rubrique",
  'project-fields.use-project-flags.project-tags-create-failure-title': 'Impossible de créer le thème',
  'project-fields.use-project-flags.project-tags-create-limit-failure-description':
    "Le nom d'étiquette que vous avez saisi est trop long. Veuillez saisir un nom d'étiquette d'au maximum 255 caractères.",
  'project-fields.use-project-flags.project-tags-create-limit-failure-title': "Impossible de créer l'étiquette",
  'project-fields.use-project-flags.project-tags-remove-failure-title': 'Impossible de supprimer la rubrique',
  'project-fields.use-project-flags.project-team-remove-failure-description':
    "Une erreur s'est produite lors de la suppression de l'équipe, veuillez réessayer",
  'project-fields.use-project-flags.related-project-remove-failure-title': 'Impossible de supprimer le projet associé',
};
